export const GridChooser = {
  extends: 'Group',
  width: '100%',
  Title: {
    text: '{{ editor.grid.options | polyglot }}'
  },
  Grid: {
    margin: '- -X2',
    templateColumns: 'repeat(12, 1fr)',
    templateRows: 'repeat(3, 1fr)',
    gap: 'X2',
    round: 'radiusControl',
    overflow: 'hidden',
    childProps: {
      opacity: '0.35',
      theme: 'space',
      minHeight: 'B1',
      round: 'X1',
      isActive: (el, s) => {
        const key = parseInt(el.key)
        const { gridOptions } = s.settings
        const h = Math.floor(key / 12) + 1
        const w = (key % 12) + 1
        return gridOptions?.w >= w && gridOptions?.h >= h
      },
      '.isActive': {
        opacity: '.85'
      },
      '!isActive': {
        ':hover': {
          opacity: '.45'
        }
      },
      onClick: (ev, el, s) => {
        const key = parseInt(el.key)
        const h = Math.floor(key / 12) + 1
        const w = (key % 12) + 1
        s.update({
          settings: {
            gridOptions: {
              w,
              h
            }
          }
        })
      }
    },
    children: () => new Array(60).fill({})
  }
}
